import {appRoouteOptions, appRoutes} from 'app/config/routeMap';
import {connectRoutes} from 'redux-first-router'


const location = connectRoutes(appRoutes, appRoouteOptions);

export const locationMiddleware = location.middleware;
export const locationEnhancer = location.enhancer;
export const locationReducer = location.reducer;
